module.exports = __webpack_public_path__ + "img/banque_edit_2.4ad398f0.jpg";